import { Injectable } from '@angular/core';
import {
  CREATE_CURRENCY,
  REMOVE_CURRENCY_BY_ID,
  UPDATE_CURRENCY_ADJUSTMENT,
} from '../graphql/mutations/currency-adjustment.mutation';
import { Apollo } from 'apollo-angular';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import {
  GET_CURRENCIES,
  GET_CURRENCY_BY_ID,
  GET_EXCHANGE_LOG_BY_CURRENCY,
} from '../graphql/queries/currency-adjustment.query';

@Injectable({
  providedIn: 'root',
})
export class CurrencyAdjustmentService {
  constructor(private apollo: Apollo, private http: HttpClient) {}

  //fetch all currencies
  fetchCurrencies(search: string = '', filter: {}): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_CURRENCIES,
        variables: { search, filter },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((response) => response.data?.currencies));
  }

  //fetch currency by id
  fetchCurrencyById(id: number): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_CURRENCY_BY_ID,
        variables: { id: id },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((response) => response.data?.currency));
  }

  //create currency
  createCurrency(createCurrencyInput: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: CREATE_CURRENCY,
      variables: {
        createCurrencyInput: createCurrencyInput,
      },
    });
  }

  //update currency
  updateCurrencyById(updateCurrencyInput: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: UPDATE_CURRENCY_ADJUSTMENT,
      variables: {
        updateCurrencyInput: updateCurrencyInput,
      },
    });
  }

  removeCurrencyById(id: number): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: REMOVE_CURRENCY_BY_ID,
      variables: { id },
    });
  }

  //fetch exchange log by currency
  fetchExchangeLog(currencyId: number): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_EXCHANGE_LOG_BY_CURRENCY,
        variables: { currencyId: currencyId },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((response) => response.data?.getExchangeRateLogByCurrency)
      );
  }
}